export const STEPS_WAR = {
  INITIALIZE: 0,
  WELCOME: 1,
  QUESTIONS: 2,
  RESULT_QUESTIONS: 3,
  WAR: 4,
};
